import { useState } from "react";

const Calendar = ({ selectedDate, onDateChange, minDate = new Date() }) => {
    const [currentDate, setCurrentDate] = useState(new Date());
    
    const getDaysInMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
    };
    
    const getFirstDayOfMonth = (date) => {
        return new Date(date.getFullYear(), date.getMonth(), 1).getDay();
    };
    
    const months = [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    
    const weekDays = ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'];
    
    const daysInMonth = getDaysInMonth(currentDate);
    const firstDay = getFirstDayOfMonth(currentDate);
    
    const handlePrevMonth = () => {
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1));
    };
    
    const handleNextMonth = () => {
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1));
    };
    
    const handleDateClick = (day) => {
        const newDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
        if (newDate >= minDate) {
            onDateChange(newDate);
        }
    };
    
    const isDateDisabled = (day) => {
        const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
        return date < minDate;
    };
    
    const isDateSelected = (day) => {
        if (!selectedDate) return false;
        const date = new Date(currentDate.getFullYear(), currentDate.getMonth(), day);
        return date.toDateString() === selectedDate.toDateString();
    };
    
    const renderCalendarDays = () => {
        const days = [];
        
        
        for (let i = 0; i < firstDay; i++) {
            days.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
        }
        
        
        for (let day = 1; day <= daysInMonth; day++) {
            const isDisabled = isDateDisabled(day);
            const isSelected = isDateSelected(day);
            
            days.push(
                <div
                    key={day}
                    className={`calendar-day ${isDisabled ? 'disabled' : 'active'} ${isSelected ? 'selected' : ''}`}
                    onClick={() => !isDisabled && handleDateClick(day)}
                >
                    {day}
                </div>
            );
        }
        
        return days;
    };
    
    return (
        <div className="calendar-container">
            <div className="calendar-header">
                <button type="button" className="btn btn-sm btn-outline-secondary calendar-arrows" onClick={handlePrevMonth}>
                    ‹
                </button>
                <span className="calendar-month-year">
                    {months[currentDate.getMonth()]} {currentDate.getFullYear()}
                </span>
                <button type="button" className="btn btn-sm btn-outline-secondary calendar-arrows" onClick={handleNextMonth}>
                    ›
                </button>
            </div>
            
            <div className="calendar-weekdays">
                {weekDays.map(day => (
                    <div key={day} className="calendar-weekday">{day}</div>
                ))}
            </div>
            
            <div className="calendar-days">
                {renderCalendarDays()}
            </div>
        </div>
    );
};
export default Calendar;